/**
 * Countdown Timer
 * Updates digit elements based on data-end-date and data-end-time.
 */

(function () {
  function parseEndDate(section) {
    const dateStr = (section.dataset.endDate || '').trim();
    const timeStr = (section.dataset.endTime || '').trim();
    if (!dateStr) return null;

    let date;
    if (timeStr) {
      date = new Date(`${dateStr}T${timeStr}:00`);
    } else {
      date = new Date(`${dateStr}T23:59:59`);
    }
    return isNaN(date.getTime()) ? null : date;
  }

  function computeRemaining(endDate) {
    const now = new Date();
    if (endDate <= now) {
      return { months: 0, days: 0, hours: 0, minutes: 0, expired: true };
    }

    const diffMs = endDate - now;
    const totalMinutes = Math.floor(diffMs / (60 * 1000));
    const totalHours = Math.floor(totalMinutes / 60);
    const totalDays = Math.floor(totalHours / 24);

    // Approximate months (30 days) and remaining days
    const months = Math.floor(totalDays / 30);
    const days = totalDays % 30;
    const hours = totalHours % 24;
    const minutes = totalMinutes % 60;

    return { months, days, hours, minutes, expired: false };
  }

  function updateSection(section) {
    const endDate = parseEndDate(section);
    const units = ['months', 'days', 'hours', 'minutes'];

    if (!endDate) {
      units.forEach((u) => {
        const digit = section.querySelector(`.countdown__digit[data-digit="${u}"]`);
        if (digit) digit.textContent = '0';
      });
      return;
    }

    const remaining = computeRemaining(endDate);

    units.forEach((u) => {
      const digit = section.querySelector(`.countdown__digit[data-digit="${u}"]`);
      if (digit) digit.textContent = String(remaining[u]).padStart(1, '0');
    });
  }

  function init() {
    const sections = document.querySelectorAll('.countdown-section[data-end-date]');
    sections.forEach((section) => {
      updateSection(section);
    });

    // Update every second (for minutes)
    setInterval(() => {
      sections.forEach(updateSection);
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
